import { render, staticRenderFns } from "./PosReport.vue?vue&type=template&id=25e3189e&scoped=true"
import script from "./PosReport.vue?vue&type=script&lang=js"
export * from "./PosReport.vue?vue&type=script&lang=js"
import style0 from "./PosReport.vue?vue&type=style&index=0&id=25e3189e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e3189e",
  null
  
)

export default component.exports